// Convert column names to user-friendly headers
export const formatColumnHeader = (columnName) => {
  if (columnName.startsWith("country_")) {
    const country = columnName.replace("country_", "").replace(/_/g, " ");
    return `${country.charAt(0).toUpperCase() + country.slice(1)} %`;
  }
  if (columnName.startsWith("language_")) {
    const language = columnName.replace("language_", "").replace(/_/g, " ");
    return `${language.charAt(0).toUpperCase() + language.slice(1)} Lang %`;
  }
  return columnName
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

// Prepare data structure for export with proper headers and formatted values
export const prepareDataForExport = ({ rows, columns, formatCellValue }) => {
  const headers = columns.map((col) => formatColumnHeader(col));
  const data = rows.map((row) => {
    const exportRow = {};
    columns.forEach((col, index) => {
      const header = headers[index];
      exportRow[header] = formatCellValue(row[col], col);
    });
    return exportRow;
  });
  return { headers, data };
};
